import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {User} from '../entity/user.model';
import {UserSummaryConverter} from './userSummary.converter';
import {Injectable} from '@angular/core';
import {DocumentSummaryConverter} from '../../../../../document/common/api/converter/DocumentSummary.converter';
import {UserAccountConverter} from './userAccount.converter';

@Injectable({
    providedIn: 'root'
})
export class UserConverter extends HttpModelConverter<User> {

    constructor(private userSummaryConverter: UserSummaryConverter,
                private documentSummaryConverter: DocumentSummaryConverter,
                private userAccountConverter: UserAccountConverter) {
        super();
    }

    protected createInstance(): User {
        return new User();
    }

    protected enrichObject(result: User, src: User) {
        result.summary = this.userSummaryConverter.convert(src.summary);
        result.accounts = this.userAccountConverter.convertFromArray(src.accounts);
        result.picture = this.documentSummaryConverter.convert(src.picture);
    }
}
